// extracted by mini-css-extract-plugin
export default {"root":"NotFoundPage_root-dXa","body":"NotFoundPage_body-H6F"};